/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ org: NonNullable<unknown> }} Onboarding_Tour_Organization_BodyInputs */



/**
* | output |
* | --- |
* | "Everything you see belongs to {org}. Admins reach its settings, members and subscription from here." |
*
* @param {Onboarding_Tour_Organization_BodyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_tour_organization_body = /** @type {((inputs: Onboarding_Tour_Organization_BodyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Tour_Organization_BodyInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Alles, was du siehst, gehört zu ${i?.org}. Admins erreichen hier Einstellungen, Mitglieder und Abonnement.`)
	return /** @type {LocalizedString} */ (`Everything you see belongs to ${i?.org}. Admins reach its settings, members and subscription from here.`)
});